import KendoBarcode from './KendoBarcode'
import KendoQRCode from './KendoQRCode'
import KendoBarcodesInstaller from './kendo-barcodes-installer'

export { KendoBarcode, KendoBarcode as Barcode, KendoQRCode, KendoQRCode as QRCode, KendoBarcodesInstaller, KendoBarcodesInstaller as BarcodesInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/index.js